import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { NotificationManager } from "react-notifications";
import {
  SaveDropdownListItem,
  UpdateDropdownListItem,
  getDropdownListErrorMessage,
} from "../../../services/DropdownListService";
import CommonLoader from "../../common/CommonLoader";

const AddEditDropdownItemDialog = ({ open, onClose, onSave, selectedItem, listType, itemLabel, maxLength }) => {
  const [value, setValue] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setValue(selectedItem?.value || "");
    setIsActive(selectedItem ? selectedItem.isActive : true);
    setError("");
  }, [open, selectedItem]);

  const handleSave = async () => {
    const trimmed = value.trim();
    if (!trimmed) {
      setError(`${itemLabel} is required`);
      return;
    }

    const item = {
      id: selectedItem?.id || 0,
      listType,
      value: trimmed,
      // Order is managed with Re-order Items; new items are added at the end of the list.
      isActive,
    };

    try {
      setLoading(true);
      if (selectedItem) {
        await UpdateDropdownListItem(item);
        NotificationManager.success(`${itemLabel} updated successfully`);
      } else {
        await SaveDropdownListItem(item);
        NotificationManager.success(`${itemLabel} added successfully`);
      }
      onSave();
      onClose();
    } catch (err) {
      console.error("Error saving dropdown item:", err);
      NotificationManager.error(await getDropdownListErrorMessage(err, `Error saving ${itemLabel.toLowerCase()}`));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{selectedItem ? `Edit ${itemLabel}` : `Add ${itemLabel}`}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label={itemLabel}
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  setError("");
                }}
                fullWidth
                margin="dense"
                size="small"
                variant="outlined"
                multiline
                minRows={2}
                required
                error={!!error}
                helperText={error || `${value.length}/${maxLength}`}
                inputProps={{ maxLength }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
                label={isActive ? "Active" : "Inactive (hidden from dropdown)"}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" color="primary" disabled={loading}>
            {selectedItem ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      <CommonLoader loading={loading} />
    </>
  );
};

export default AddEditDropdownItemDialog;
